import { render, staticRenderFns } from "./SaludoToAllOurAthletesTokyo2020.vue?vue&type=template&id=46e1dc96&scoped=true"
import script from "./SaludoToAllOurAthletesTokyo2020.vue?vue&type=script&lang=js"
export * from "./SaludoToAllOurAthletesTokyo2020.vue?vue&type=script&lang=js"
import style0 from "./SaludoToAllOurAthletesTokyo2020.vue?vue&type=style&index=0&id=46e1dc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e1dc96",
  null
  
)

export default component.exports